import { SectionHeader } from "./SectionHeader";
import type { SectionHeaderProps } from "./SectionHeader.d";

export { SectionHeader, SectionHeaderProps };
